<template>
  <v-app :style="{ background: '#f5f7fa' }">
    <SuperiorMenu />

    <v-main>
      <!-- Contenedor Principal -->
      <v-container fluid class="fill-height align-start pa-0">
        <v-fade-transition mode="out-in">
          
          <!-- CASO 1: Selector de Cliente para Ramos -->
          <div v-if="esRamos && !$route.meta.hideClientSelector && !esRutaMantenimiento" class="w-full" style="width: 100%">
            
            <!-- Banner de Selección de Cliente COMPACTO y SIN LÍMITES DE ANCHO -->
            <v-sheet elevation="1" class="py-2 px-4 border-bottom" color="white">
              <v-row align="center" no-gutters>
                <!-- Título a la izquierda para ahorrar espacio vertical -->
                <v-col cols="12" sm="auto" class="pr-4 hidden-xs-only">
                  <div class="text-subtitle-1 font-weight-bold primary--text">Panel de Gestión</div>
                </v-col>

                <!-- Buscador ocupando el resto del espacio -->
                <v-col>
                  <v-autocomplete
                    v-model="clienteSeleccionado"
                    :items="clientes"
                    item-text="nombre"
                    item-value="id_cliente"
                    label="Seleccionar cliente..."
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    hide-details
                    flat
                    background-color="grey lighten-4"
                    clearable
                    class="rounded-lg custom-autocomplete"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{ item.nombre }}</v-list-item-title>
                        <v-list-item-subtitle class="caption">ID: {{ item.id_cliente }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-sheet>

            <!-- Área de Contenido (Cambiado a FLUID y pa-0 para eliminar márgenes laterales) -->
            <v-container fluid class="pa-0">
              <v-scroll-y-transition mode="out-in">
                <div v-if="clienteSeleccionado" :key="clienteSeleccionado">
                  <router-view />
                </div>
                
                <!-- Estado Vacío -->
                <v-row v-else justify="center" class="mt-12 mx-0">
                  <v-col cols="12" sm="8" md="6" class="text-center">
                    <v-icon size="80" color="grey lighten-2">mdi-account-search-outline</v-icon>
                    <h3 class="text-h6 grey--text mt-4">Selecciona un cliente para comenzar</h3>
                  </v-col>
                </v-row>
              </v-scroll-y-transition>
            </v-container>
          </div>

          <!-- CASO 2: Usuario Normal (Se mantiene como estaba) -->
          <v-container v-else fluid class="pa-0">
            <router-view />
          </v-container>

        </v-fade-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SuperiorMenu from "@/components/layout/SuperiorMenu.vue";
import axios from "axios";

export default {
  name: "App",
  components: { SuperiorMenu },

  data() {
    return {
      mounted: false,
      clienteSeleccionado: null
    };
  },

  computed: {
    ...mapState(["all_articles", "idCliente", "esRamos", "clientes"]),
    esRutaMantenimiento() {
      return this.$route.path.startsWith('/mantenimiento');
    },
  },

  methods: {
    ...mapActions(["postDataWithReturn", "setAllArticles", "setOrders","setEsRamos",'setClientId', 'retrieveToken', 'retrieveClientId', "storePartnerId", "storeIdCliente", "storeUserAfterCharge", "getData"]),
    ...mapGetters(["getPartnerId", "getIdCliente"]),
    
    async getArticles(partner_id) {
      if (!this.all_articles?.length && partner_id != null) {
        // partner_id = 70 //borrar
        const { artículos: articles } = await this.postDataWithReturn({ path: "django/portal/articulos/", body: { partner_id: partner_id } });
        const { orders } = await this.getData({ path: `django/portal/get_orders/?partner_id=${partner_id}` });

        // articles.map((a) => a.qty_available = 100); //borrar
        this.setAllArticles(articles.map((a) => ({ quantity: a.qty_available > 0 ? 1 : 0, in_cart: false, note: a.qty_available > 0 ? false : true,...a })));
        this.setOrders(orders);
      }
    },
  },

  async mounted() {     // si aún la usas (¿es necesaria?)
    await this.retrieveClientId();   // ✅ ahora esto hace TODO

    let partner_id = this.getPartnerId();

    try {
  
      if(!this.esRamos){
        this.getArticles(partner_id);
      }
  
      this.mounted = true;
    } catch(e) {
      console.error("errror al cargar datos", e);
    }

  },

  watch: {
    clienteSeleccionado(v) {
      this.setClientId(v);
    },
    '$route.query.qr': {
      immediate: true,
      async handler(newVal) {
        if (newVal) {

          const res = await axios.get(`/api/nodejs/armarios/cliente/${newVal}`);
        
          const idDetectado = res.data?.client_id
          
          this.clienteSeleccionado = parseInt(idDetectado);
        }
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Línea sutil para separar el selector del contenido */
.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}

.custom-autocomplete >>> .v-input__control {
  border-radius: 8px !important;
}

/* Ajuste para que el texto del autocomplete no se vea apretado */
.custom-autocomplete >>> .v-input__slot {
  min-height: 40px !important;
}

.w-full {
  width: 100%;
}
</style>